export default __webpack_public_path__ + "3dd4a2560cde1d33f9b0aea5b0533084.svg";